import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import ProformaCard from '../../ContenidoTablas/ProformaCard';
import {fetchProformas} from '../../../../actions';
import Alert from '../../../../components/Alert';
import EliminarProforma from './EliminarProforma';
import AsociarPedidos from './AsociarPedidos';
import getTipoEquipos from '../../../../utils/getTipoEquipos';
import getPedidosFechas from '../../../../utils/getPedidosFechas';
import deassignProforma from '../../../../utils/deassignProforma';
import getPedidosPedidos from '../../../../utils/getPedidosPedidos';
import getPedidosTracking from '../../../../utils/getPedidosTracking';
import getPedidosFacturacion from '../../../../utils/getPedidosFacturacion';
import getPedidosPagos from '../../../../utils/getPedidosPagos';
import getPedidosColores from '../../../../utils/getPedidosColores';
import getPedidosValidaciones from '../../../../utils/getPedidosValidaciones';
import ErrorUIComponent from '../../../../utils/ErrorUIComponent';
import { FadeLoader } from 'react-spinners';



class Proformas extends Component {
  constructor(props) {
    super(props);

    this.state = {
      proformaSeleccionada: '',
      proformaDesasignar: '',
      modalOpen: '',
      pedidosConCheck:[],
      alertWarningOpen: false,
      alertWarningMessage: '',
      pedidosXfichaVentaBonos:[],
      tipoAdicional:[],
      idsProformas: [],
      activeFilterPedido:1,
      pedidosXfichaVenta:[],
      indSelectAll:0,
      listaCorreos:props.listaCorreos//Req 92528 ebarboza 30 08 2021

    };
  }

  componentDidMount() {
    getPedidosPedidos(this.props.fdvID, this.props.idsProformas).then((result) => {
          this.setState({  pedidosXfichaVentaBonos: result });
        }).catch((error) => { console.log(error); });
        getTipoEquipos(this.props.fdv.codAreaVta).then((result)=>{
        this.setState({tipoAdicional:result.data.itemList});
      }
    );

    this.props.fetchProformas(this.props.fdvID);
    this.loadProformas(this.props.fdvID);

 }

  fnPedidosConCheck=(pedidosConCheck)=>{

    let array=pedidosConCheck;
    this.setState({pedidosConCheck:array});
  }

  fnVaciarPedidosConCheck = () => {
    this.setState({pedidosConCheck:[]});
  }

  closeAlert = () => this.setState({ alertWarningOpen: false});



  openAlert = (data) => {
    if (data.estadoTrama === '0') {
      this.setState({ alertWarningMessage: data.mensaje });
      this.showAlert('alertWarningOpen');
    } else if (data.estadoTrama === '1') {
      this.setState({ alertSuccessMessage: data.mensaje });
      this.showAlert('alertSuccessOpen');
    } else {
      this.setState({ alertErrorMessage: `Hubo un error con el servicio ${data.estadoTrama}` });
      this.showAlert('alertErrorOpen');
    }
  }

  showAlert = (alertType) => {
    this.setState({ [alertType]: true });
    setTimeout(() => this.setState({ [alertType]: false }), 5000);
  }

  selectProforma = (itemProforma) => {
    if (this.state.proformaSeleccionada === itemProforma) {
      this.setState({ proformaSeleccionada: '',proforma:'' });
    } else {
      this.setState({ proformaSeleccionada: itemProforma,proforma:this.props.proformas.proformaExistenteList.map(row => row.numProfVeh === itemProforma) });
    }
  }

  openModalDesasignar = (proforma) => {
    this.setState({ modalOpen: 'EliminarProforma', proformaDesasignar: proforma });
  }

  openModalPedidos = (proforma) => {
    this.setState({ modalOpen: 'AsociarPedidos', proforma });
  }

  closeModal = () => {
    this.setState({ modalOpen: '', proformaDesasignar: '', proforma: '' });
    this.changeIndex(1);
  }

  desasignar = () => {
    deassignProforma(this.props.fdvID, this.state.proformaDesasignar)
      .then(({ data }) => {
        this.props.openAlert(data);
      this.loadProformas(this.props.fdvID);

      }, ()=> this.closeModal());

      this.setState({modalOpen:'none'});
  }


  loadProformas = (id) => {
    this.setState({pedidosConCheck: []});

    this.props.fetchProformas(id).then((result) => {

      const idsProformas = result.payload.data.proformaExistenteList.map(row => row.numProfVeh);
      getPedidosFechas(id, idsProformas).then((result2) => {
        this.setState({ pedidosXfichaVenta: result2 });
      });


      this.setState({ idsProformas });

    }).catch((error) => {
      console.log(error);
    });
  }

  fnChangeindSelectAll = () => {
    this.setState({indSelectAll:this.state.indSelectAll+1})
  }


  changeIndex = (estadoActivo) => {

console.log('estadoActivo1',estadoActivo);
    this.setState({ muestraLoad: 'block', pedidosXfichaVenta: [] });
    switch (estadoActivo) {
      case 0:
        getPedidosFechas(this.props.fdvID, this.props.idsProformas).then((result) => {

          this.props.pedidosXfichaVentaChange(result);
          this.setState({ muestraLoad: 'none', pedidosXfichaVenta: result });
        }).catch((error) => { console.log(error); this.setState({ muestraLoad: 'none' }); });
        break;
      case 1:
        getPedidosPedidos(this.props.fdvID, this.props.idsProformas).then((result) => {
          this.props.pedidosXfichaVentaChange(result);
          this.setState({ muestraLoad: 'none', pedidosXfichaVenta: result });
        }).catch((error) => { console.log(error); this.setState({ muestraLoad: 'none' }); });
        break;
      case 2:
        getPedidosTracking(this.props.fdvID, this.props.idsProformas).then((result) => {
          this.props.pedidosXfichaVentaChange(result);
          this.setState({ muestraLoad: 'none', pedidosXfichaVenta: result });
        }).catch((error) => { console.log(error); this.setState({ muestraLoad: 'none' }); });
        break;
      case 3:
        getPedidosFacturacion(this.props.fdvID, this.props.idsProformas).then((result) => {
          this.props.pedidosXfichaVentaChange(result);
          this.setState({ muestraLoad: 'none', pedidosXfichaVenta: result });
        }).catch((error) => { console.log(error); this.setState({ muestraLoad: 'none' }); });
        break;
      case 4:
        getPedidosPagos(this.props.fdvID).then((result) => {
          this.props.pedidosXfichaVentaChange(result);
          this.setState({ muestraLoad: 'none', pedidosXfichaVenta: result });
        }).catch((error) => { console.log(error); this.setState({ muestraLoad: 'none' }); });
        break;
      case 5:
        getPedidosColores(this.props.fdvID, this.props.idsProformas).then((result) => {
          this.props.pedidosXfichaVentaChange(result);
          this.setState({ muestraLoad: 'none', pedidosXfichaVenta: result });
        }).catch((error) => { console.log(error); this.setState({ muestraLoad: 'none' }); });
        break;
      case 6:
        getPedidosValidaciones(this.props.fdvID, this.props.idsProformas).then((result) => {
          this.props.pedidosXfichaVentaChange(result);
          this.setState({ muestraLoad: 'none', pedidosXfichaVenta: result });
        }).catch((error) => { console.log(error); this.setState({ muestraLoad: 'none' }); });
        break;
      default:
        break;
    }

    this.setState({indSelectAll:0})
    this.setState({ activeFilterPedido: estadoActivo });
  }

  fnChangeIndInitialize = () => {
    this.setState({indSelectAll:0})
  }

  loading = (status) =>{
    this.setState({ muestraLoad: status });
  }


  render() {
    const { proformaSeleccionada, proformaDesasignar, modalOpen, proforma } = this.state;
    return (
      <div>
          <section className='fdv-section' id='proformas'>
            <header className='fdv-section-head'>
              <h5 className='fdv-section-title'>Proformas</h5>
              <div className='fdv-section-actions'>
                <button className='btn btn-primary btn-sm' onClick={(e) => this.props.handlePermissions(e) && this.props.openModal('nueva-proforma')} data-permisos='ind_asociar_proforma'>Asociar proforma</button>
              </div>
            </header>
            {
              this.props.proformas.proformaExistenteList.map(prof => (
                <ErrorUIComponent>
                <ProformaCard
                  pedidos={this.props.pedidosXfichaVenta}
                  proforma={prof}
                  selectProforma={this.selectProforma}
                  proformaSeleccionada={proformaSeleccionada}
                  fdvState={this.props.fdvState}
                  fdvID={this.props.fdvID}
                  openModal={this.props.openModal}
                  openModalDesasignar={this.openModalDesasignar}
                  openModalPedidos={this.openModalPedidos}
                  openAlert={this.props.openAlert}
                  loading={this.loading}
                  searchProveedorEquiposAdicionales={this.props.searchProveedorEquiposAdicionales}
                  proveedorEquipoLogistica={this.props.proveedorEquipoLogistica}
                  fnCantidadPrecioEquipo={this.fnCantidadPrecioEquipo}
                  proveedorEquposAdicionales={this.props.proveedorEquposAdicionales}
                  equiposLogistica={this.props.equiposLogistica}
                  fdv={this.props.fdv}
                  nurPedidos={this.props.nurPedidos}
                  pedidosXfichaVentaBonos = {this.state.pedidosXfichaVentaBonos}
                  fnSolicitudFacturacion={this.props.fnSolicitudFacturacion}
                  fnListadoPedidosFacturacion={this.props.fnListadoPedidosFacturacion}
                  fnPedidosConCheck={this.fnPedidosConCheck}
                  loadProformas={this.props.loadProformas}
                  traerFacturacion={this.props.traerFacturacion}
                  validarAsignacion={this.props.validarAsignacion}
                  loadPage = {this.props.loadPage}
                  fnVaciarPedidosConCheck={this.fnVaciarPedidosConCheck}
                  idsProformas={this.state.idsProformas}
                  changeIndex = {this.changeIndex}
                  activeFilterPedido = {this.state.activeFilterPedido}
                  pedidosXfichaVenta = {this.props.pedidosXfichaVenta}
                  indSelectAll={this.state.indSelectAll}
                  fnChangeindSelectAll={this.fnChangeindSelectAll}
                  fnChangeIndInitialize={this.fnChangeIndInitialize}
                  handlePermissions={this.props.handlePermissions}
                  handlePermissionsMassive={this.props.handlePermissionsMassive}
                  doneAsignacionDefinitiva={this.props.doneAsignacionDefinitiva}
                  isFinishedAsignacionDefinitiva={this.props.isFinishedAsignacionDefinitiva}
                  listaCorreos={this.state.listaCorreos}//Req 92528 ebarboza 30 08 2021
                />
                </ErrorUIComponent>

              ))
            }
            {
              modalOpen === 'EliminarProforma' &&
              <ErrorUIComponent>

                <EliminarProforma
                  closeModal={this.closeModal}
                  proforma={proformaDesasignar}
                  desasignar={this.desasignar}
                />
                </ErrorUIComponent>

            }
            { modalOpen === 'AsociarPedidos' &&
               <ErrorUIComponent>
              <AsociarPedidos
                closeModal={this.closeModal}
                proforma={proforma}
                fdv={this.props.fdv}
                openAlert={this.props.openAlert}
                pedidosConCheck={this.state.pedidosConCheck}
                openAlertModal={this.openAlert}
                traerFacturacion={this.props.traerFacturacion}
                pedidosProforma={this.props.pedidosXfichaVenta}
                validarAsignacion={this.props.validarAsignacion}
                loadProformas={this.props.loadProformas}
               // changeIndex = {this.changeIndex}
              />
              </ErrorUIComponent>

            }
          </section>
          { this.state.alertWarningOpen &&
            <Alert type='alert-warning alertModal' icon='ion-alert-circled' closeAlert={this.closeAlert}>
              <p>{this.state.alertWarningMessage}</p>
            </Alert>
          }
          <div className='modal extraFilter' role='dialog' data-backdrop='static' style={{ display: this.state.muestraLoad }} >
          <div className='modal-dialog modal-sm' role='document'>
            <FadeLoader color={'#F8A14A'} loading />
          </div>
        </div>
      </div>
    );
  }
}

Proformas.defaultProps = {
  proformas: [],
  pedidos: [],
};

function mapStateToProps(state) {
  return{
    proformas:state.proformas
  };
}

export default withRouter(
  connect(mapStateToProps,{
    fetchProformas,

  })(Proformas));


//export default Proformas;



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/TabViews/Proformas/Proformas.js